import React from "react";
import {
  Paper,
  Typography,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Box,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const AppointmentSkeleton = () => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" fontWeight={600}>
        Fill The Following Details to Book your appointment
      </Typography>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Source:{" "}
        <Typography color="text.coralRed" component="span">
          Online Booking Appointment for service
        </Typography>
      </Typography>
      <Box
        sx={{
          height: 170,
          backgroundColor: "#e0e0e0",
          borderRadius: 2,
          mb: 2,
          padding: 2,
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#c9c3c3",
            borderRadius: "12px",
            height: "94%",
            width: { sm: "94%", md: "20%" },
          }}
        ></Box>
      </Box>
      <Box
        sx={{ mt: 2, backgroundColor: "#e0e0e0", height: 40, borderRadius: 2 }}
      ></Box>
      <Box sx={{ display: "flex", mt: 2 }}>
        <Box
          sx={{
            width: "33%",
            height: 40,
            backgroundColor: "#e0e0e0",
            borderRadius: 2,
            mr: 1,
          }}
        ></Box>
        <Box
          sx={{
            width: "33%",
            height: 40,
            backgroundColor: "#e0e0e0",
            borderRadius: 2,
            mr: 1,
          }}
        ></Box>
        <Box
          sx={{
            width: "33%",
            height: 40,
            backgroundColor: "#e0e0e0",
            borderRadius: 2,
          }}
        ></Box>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          1. Car brand
        </Typography>
        <Box
          sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
        ></Box>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          2. Model
        </Typography>
        <Box
          sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
        ></Box>
      </Box>{" "}
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          3. Plate Name
        </Typography>
        <Box
          sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
        ></Box>
      </Box>{" "}
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          4. Car Serial Number
        </Typography>
        <Box
          sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
        ></Box>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          5. Last Inspection
        </Typography>
        <Box
          sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
        ></Box>
      </Box>
      <Typography variant="h6" fontWeight={600} my={2}>
        Select Date and Time
      </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
          ></Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{ height: 40, backgroundColor: "#e0e0e0", borderRadius: 2 }}
          ></Box>
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight={600} my={2}>
          Answer the following Questions (Regarding the service)
        </Typography>
        <Box
          sx={{
            height: 60,
            backgroundColor: "#e0e0e0",
            borderRadius: 2,
            mb: 2,
          }}
        ></Box>
        <Box
          sx={{
            height: 60,
            backgroundColor: "#e0e0e0",
            borderRadius: 2,
            mb: 2,
          }}
        ></Box>
      </Box>
      <Stack
        direction={{ sm: "row" }}
        alignItems={{ sm: "center" }}
        justifyContent={{ sm: "space-between" }}
        sx={{ mt: 2 }}
      >
        <Typography variant="h6" fontWeight={600}>
          Total Price: -- EUR
        </Typography>
        <Typography variant="h6" fontWeight={600}>
          Total Duration: --
        </Typography>
      </Stack>
      <Box
        sx={{ mt: 2, height: 150, backgroundColor: "#e0e0e0", borderRadius: 2 }}
      ></Box>
      <Typography variant="h6" fontWeight={600} my={2}>
        Description
      </Typography>
      <Box
        sx={{ height: 100, backgroundColor: "#e0e0e0", borderRadius: 2 }}
      ></Box>
    </Paper>
  );
};

export default AppointmentSkeleton;
